import { connect } from 'react-redux'
import { VzPageContainer } from '../../../layouts/VzPageContainer'
import { Tabs, Tab } from 'react-bootstrap'
import { isPermittedPage } from '../../../apis/Utility'
import MonthlyDeliverymanUniqueShopsReport from './MonthlyDeliverymanUniqueShopsReport/MonthlyDeliverymanUniqueShopsReport'
import DayWiseDeliverymanUniqueShopsReport from './DayWiseDeliverymanUniqueShopsReport/DayWiseDeliverymanUniqueShopsReport'

const DeliverymanUniqueShopsReport = (props) => {
    return (
        <div>
            <VzPageContainer title='Deliveryman Unique Shops Report'>
                <Tabs
                    defaultActiveKey=
                    {
                        isPermittedPage('Day Wise', props.actions, props.userRole) ? 'DayWise' : 'Monthly'
                    }
                    id='uncontrolled-tab-example'
                    className='mb-3'
                >
                    {isPermittedPage('Day Wise', props.actions, props.userRole) &&
                        <Tab eventKey='DayWise' title='Day Wise'>
                            <DayWiseDeliverymanUniqueShopsReport actions={props.actions}></DayWiseDeliverymanUniqueShopsReport>
                        </Tab>
                    }
                    {isPermittedPage('Monthly', props.actions, props.userRole) &&
                        <Tab eventKey='Monthly' title='Monthly'>
                            <MonthlyDeliverymanUniqueShopsReport actions={props.actions}></MonthlyDeliverymanUniqueShopsReport>
                        </Tab>
                    }
                </Tabs>
            </VzPageContainer>
        </div>
    )
}

export default connect()(DeliverymanUniqueShopsReport)
